import React from "react"
import { withStyles } from '@material-ui/core';

const styles = () => ({
  root: {
    width: 100,
    height: 86,
    borderRadius: 10,
    background: "#f9f9f9",
    cursor: "pointer",
    marginRight: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlignLast: "center",
    fontSize: 16,
    "&:hover": {
      color: "#26bbed",
    },
    "&:hover path": {
      fill: "#26bbed",
    },
  },
  textStyle: {
    marginTop: 8
  }

})


const ShareButton = ({ text, icon, classes, onClick }) => {
  return (
    <div className={classes.root} onClick={onClick}>
      <div>
        <div>{icon}</div>
        <div className={classes.textStyle}>{text}</div>
      </div>
    </div>
  )
}

export default withStyles(styles)(ShareButton)